import { Dispatch, SetStateAction } from 'react';
import { useFetchFavoriteData } from 'newhooks/sportsbook/favorites/useFetchFavoriteData';

type TUseFetchFavoriteDataProps = {
  additionalMarkets?: boolean;
  setLoading?: Dispatch<SetStateAction<boolean>>;
};

export const FetchFavoriteData = (
  options?: TUseFetchFavoriteDataProps
): null => {
  useFetchFavoriteData(options);

  return null;
};
